export default {
  course: { text: "Course coupons", url: 'course' },
  subscription: { text: "Subscription coupons", url: 'subscription' },
};
